import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { I18n } from '../../helpers/i18n';
import { sendForgotPasswordCode } from 'redux/actions/user.action';
import warning from 'static/images/mvp/warning.png';
import config from '../../config';
import './signin.scss';
import {
  Button,
  FormField,
  FormSection,
  Input,
  InputLabel,
  SectionBody,
  SectionFooter,
  SectionHeader,
} from 'aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React';
import { formTheme } from './ThemeSignIn';

const ForgotPassword = ({ sendForgotPasswordCode, loading, history, header }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      );
  };

  const handleSendCode = async () => {
    setError('');
    if (!email) {
      setError(I18n.t('text_field_required_error'));
      return;
    }
    if (!validateEmail(email)) {
      setError(I18n.t('email_invalid'));
      return;
    }

    setIsProcessing(true);
    try {
      await sendForgotPasswordCode(email);
      // Redirect to confirmation page with email
      history.push(`/forgot-password-confirm?email=${encodeURIComponent(email)}`);
    } catch (err) {
      setIsProcessing(false); // Reset processing state on error
      if (err.message.includes('not found') || err.message.includes('400.63')) {
        setError(I18n.t('forgot_password_email_not_found'));
      } else {
        setError(err.message || I18n.t('something_wrong'));
      }
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSendCode();
    }
  };

  const theme = {
    input: {
      color: '#000000',
      fontSize: '16px',
      lineHeight: '24px',
      borderColor: error ? '#FF445D' : '#CCCCCC',
      borderRadius: '4px',
      padding: '14px 16px',
    },
  };

  return (
    <div id="site_wrapper">
      {header}
      <FormSection theme={formTheme} style={{ width: 460 }}>
        <SectionHeader theme={formTheme}>{I18n.t('forgot_password_modal_title')}</SectionHeader>
        <SectionBody style={{ marginBottom: 24 }}>
          <div className="content" style={{ opacity: 0.7, fontSize: '16px', marginBottom: '25px', lineHeight: '1.5' }}>
            <span>{I18n.t('forgot_password_modal_description')}</span>
          </div>
          
          <FormField>
            <InputLabel theme={formTheme}>{I18n.t('senior_account_account_info_email_label')} <span className="text-danger">*</span></InputLabel>
            <Input
              placeholder={I18n.t('forgot_password_email_placeholder')}
              key="email"
              name="email"
              type="email"
              value={email}
              theme={theme}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={isProcessing || loading}
            />
            {error && (
              <span className="error-message">
                <img src={warning} style={{ marginTop: '-5px', marginRight: '4px' }} alt="Warning" />
                {error}
              </span>
            )}
            {success && (
              <span className="success-message">
                {success}
              </span>
            )}
          </FormField>
        </SectionBody>
        <SectionFooter theme={formTheme}>
          <Button 
            theme={formTheme} 
            onClick={handleSendCode} 
            disabled={isProcessing || loading}
            style={isProcessing ? {
              backgroundColor: '#CCCCCC',
              color: '#FFFFFF',
              cursor: 'not-allowed'
            } : {}}
          >
            {isProcessing ? I18n.t('processing') : I18n.t('forgot_password_send_code')}
          </Button>
          <Link to="/login" style={{ color: '#01ECC3', textDecoration: 'underline' }}>
            {I18n.t('forgot_password_back_to_login')}
          </Link>
        </SectionFooter>
      </FormSection>
    </div>
  );
};

const mapStateToProps = ({ user }) => ({
  loading: user.loading,
});

const mapDispatchToProps = {
  sendForgotPasswordCode,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ForgotPassword));
